export default __webpack_public_path__ + "static/media/atome-logo.a8ef7063.png";